export const slugs = {
    home: { en: '', es: '', pt: '' },
    companies: { en: 'companies', es: 'companies', pt: 'companies' },
    podcast: {
        en: 'edutalks-digital-credentials',
        es: 'edutalks-credenciales-digitales',
        pt: 'edutalks-credenciais-digitais',
    },
    prices: {
        en: 'prices-digital-credentials',
        es: 'precios-credenciales-digitales',
        pt: 'precos-credenciais-digitais',
    },
    features: {
        en: 'features-platform-digital-credentials-nft',
        es: 'funcionalidades-plataforma-credenciales-digitales-nft',
        pt: 'funcionalidades-plataforma-credenciais-digitais-nft',
    },
    team: {
        en: 'team',
        es: 'nuestro-equipo',
        pt: 'nosso-time',
    },
    faqs: {
        en: 'frequently-asked-questions',
        es: 'preguntas-frecuentes',
        pt: 'perguntas-frequentes',
    },
    compareCredly: {
        en: 'compare/credly-vs-pok',
        es: 'comparar/credly-vs-pok',
        pt: 'comparar/credly-vs-pok',
    },
    compareAccredible: {
        en: 'compare/accredible-vs-pok',
        es: 'comparar/accredible-vs-pok',
        pt: 'comparar/accredible-vs-pok',
    },
    compareBadgr: {
        en: 'compare/badgr-vs-pok',
        es: 'comparar/badgr-vs-pok',
        pt: 'comparar/badgr-vs-pok',
    },
    compareAcreditta: {
        en: 'compare/acreditta-vs-pok',
        es: 'comparar/acreditta-vs-pok',
        pt: 'comparar/acreditta-vs-pok',
    },
    compareCertifier: {
        en: 'compare/certifier-vs-pok',
        es: 'comparar/certifier-vs-pok',
        pt: 'comparar/certifier-vs-pok',
    },
    compareHub: {
        en: 'compare',
        es: 'comparar',
        pt: 'comparar',
    },
    gg: {
        en: 'digital-credentials/guido-grinbaum',
        es: 'credenciales-digitales/guido-grinbaum',
        pt: 'credenciais-digitais/guido-grinbaum',
    },
    dc: { en: 'digital-credentials', es: 'credenciales-digitales', pt: 'credenciais-digitais' },
    mc: {
        en: 'digital-credentials/microcredentials',
        es: 'credenciales-digitales/microcredenciales',
        pt: 'credenciais-digitais/microcredenciais',
    },
    ob: {
        en: 'digital-credentials/open-badge-3-0',
        es: 'credenciales-digitales/open-badge-3-0',
        pt: 'credenciais-digitais/open-badge-3-0',
    },
    iee: {
        en: 'digital-credentials/iee-equivalency',
        es: 'credenciales-digitales/iee-equivalency',
        pt: 'credenciais-digitais/iee-equivalency',
    },
    employability: {
        en: 'features/employability-digital-credentials',
        es: 'funcionalidades/empleabilidad-credenciales-digitales',
        pt: 'funcionalidades/empregabilidade-credenciais-digitais',
    },
    whiteLabel: {
        en: 'features/white-label-digital-credentials',
        es: 'funcionalidades/marca-blanca-credenciales-digitales',
        pt: 'funcionalidades/marca-branca-credenciais-digitais',
    },
    integrations: {
        en: 'features/integrations-lms-crm-digital-credentials',
        es: 'funcionalidades/integraciones-lms-crm-credenciales-digitales',
        pt: 'funcionalidades/integracoes-lms-crm-credenciais-digitais',
    },
    learningPaths: {
        en: 'features/learning-paths-digital-credentials',
        es: 'funcionalidades/rutas-aprendizaje-credenciales-digitales',
        pt: 'funcionalidades/rotas-aprendizagem-credenciais-digitais',
    },
    marketing: {
        en: 'features/digital-credentials-marketing',
        es: 'funcionalidades/marketing-credenciales-digitales',
        pt: 'funcionalidades/marketing-credenciais-digitais',
    },
    signature: {
        en: 'features/digital-signature-digital-credentials',
        es: 'funcionalidades/firma-digital-credenciales-digitales',
        pt: 'funcionalidades/assinatura-digital-credenciais-digitais',
    },
    massive: {
        en: 'features/bulk-issuance-digital-credentials',
        es: 'funcionalidades/emision-masiva-credenciales-digitales',
        pt: 'funcionalidades/emissao-massiva-credenciais-digitais',
    },
    designer: {
        en: 'features/certificate-template-designer',
        es: 'funcionalidades/disenador-plantillas-certificados',
        pt: 'funcionalidades/designer-modelos-certificados',
    },
    verification: {
        en: 'features/digital-credential-verification',
        es: 'funcionalidades/verificacion-credenciales-digitales',
        pt: 'funcionalidades/verificacao-credenciais-digitais',
    },
    campaigns: {
        en: 'features/email-campaigns-digital-credentials',
        es: 'funcionalidades/campanas-email-credenciales-digitales',
        pt: 'funcionalidades/campanhas-email-credenciais-digitais',
    },
    lookup: {
        en: 'features/public-credential-search',
        es: 'funcionalidades/consulta-certificados-titulos',
        pt: 'funcionalidades/consulta-certificados-diplomas',
    },
    skillsGraphs: {
        en: 'products/skills-graphs-curriculum-skills-mapping',
        es: 'productos/skills-graphs-mapa-competencias-malla-curricular',
        pt: 'produtos/skills-graphs-mapa-competencias-curriculo',
    },
    skillsIntelligence: {
        en: 'products/skills-intelligence-workforce-skills-gap',
        es: 'productos/skills-intelligence-brechas-competencias-empresas',
        pt: 'produtos/skills-intelligence-lacunas-competencias-empresas',
    },
    corporateLeads: {
        es: 'leads-corporativo',
    },
};
